/** Washington Gas customer-service number, interpolated as `{{phone}}`. */
export const WGL_SUPPORT_PHONE = "844-WASHGAS (844-927-4427)";
